var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListStudySessions',{staticClass:"mb-3",attrs:{"studyId":_vm.studyId,"queryFn":_vm.createQuery,"hiddenFields":['duration', 'completed', 'runState'],"sessionRoute":"Run.Group.Live.Session","showFilter":false}})}
var staticRenderFns = []

export { render, staticRenderFns }